import React, { startTransition, useEffect, useState } from "react";
import { Card, Col, Container, Row, Form } from "react-bootstrap";
import { getHospitalData } from "../../api/Hospital";
import * as configuration from "../../config/app-config.js";
import { Empty, Input, Pagination, Tooltip } from "antd";
import Loader from "../../customJS/Loader.jsx";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, useNavigate } from "react-router-dom";
import noLogo from "../../images/noImage.svg";

function HospitalList() {
  const [hospitals, setHospitals] = useState([]);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginationCount, setPaginationCount] = useState(0);
  const navigate = useNavigate();
  // const [isPending, startTransition] = useTransition();

  useEffect(() => {
    let timer = setTimeout(() => {
      // getHospitalList();
      startTransition(() => {
        getHospitalList();
      });
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [currentPage, search]);

  function getHospitalList() {
    setLoader(true);
    const dbdata = { flag: "A", search, pageNo: currentPage };
    getHospitalData(dbdata)
      .then((response) => {
        if (response.data.status === 1) {
          setLoader(false);
          const data = response.data.data;
          startTransition(() => {
            setHospitals(data);
            setPaginationCount(data.totalCount);
          });
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        setLoader(false);
        console.error("Error fetching hospital data:", error.message);
      });
  }

  // Filter hospitals based on search term
  // const filteredHospitals = hospitals.hospitalList.filter((hospital) =>
  //   hospital.hospitalName.toLowerCase().includes(search.toLowerCase())
  // );

  const onPageChange = (newCurrent) => {
    setCurrentPage(newCurrent - 1);
  };

  const onSearch = (e) => {
    setSearch(e.target.value);
    setCurrentPage(0);
  };

  const handleClickHospitalCard = (hospitalId) => {
    navigate("/admin/viewHospital", {
      state: { hospitalId: hospitalId },
    });
  };

  return (
    <div className="mt-5">
      {loader && <Loader />}
      <Container>
        {/* Summary Section */}
        <Row className="mb-4">
          <Col lg={3}>
            <Card className="topCart">
              <Card.Body>
                <Card.Title>
                  <h4>{hospitals.totalCount ?? 0}</h4>
                </Card.Title>
                <Card.Text>
                  <b>Total Providers</b>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={3}>
            <Card className="topCart">
              <Card.Body>
                <Card.Title>
                  <h4>{hospitals.pendingRequest ?? 0}</h4>
                </Card.Title>
                <Card.Text>
                  <b>Pending Requests</b>
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col>
            <div className="d-flex align-items-center  justify-content-end">
              <Link className="uniteButton-lg" to="/admin/addClinic">
              <Icon icon="vaadin:hospital" width="21" height="21" /> {" "} Add Provider
              </Link>
            </div>
          </Col>
        </Row>

        {/* Search Section */}
        <Row className="mb-4">
          <Col xl={4}>
            <Input
              size="large"
              className="hospital-search"
              value={search}
              onChange={(e) => onSearch(e)}
              placeholder="Search Providers..."
              suffix={
                <Icon
                  icon="material-symbols:search-rounded"
                  width="24"
                  height="24"
                  style={{ color: "#2607e5" }}
                />
              }
            />

            {/* <div className="d-flex align-items-center">
              <Form.Control
                type="text"
                placeholder="Search hospitals"
                className="hospital-search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                className="search-icon"
              >
                <path
                  fill="#0f44b9"
                  d="m19.6 21l-6.3-6.3q-.75.6-1.725.95T9.5 16q-2.725 0-4.612-1.888T3 9.5t1.888-4.612T9.5 3t4.613 1.888T16 9.5q0 1.1-.35 2.075T14.7 13.3l6.3 6.3zM9.5 14q1.875 0 3.188-1.312T14 9.5t-1.312-3.187T9.5 5T6.313 6.313T5 9.5t1.313 3.188T9.5 14"
                />
              </svg>
            </div> */}
          </Col>
        </Row>

        {/* Hospital List */}
        <Row className="g-4 mb-5">
          {hospitals?.hospitalList?.length > 0 ? (
            hospitals?.hospitalList.map((hospital, index) => (
              <Col key={index} xl={4} md={6} sm={12} className="d-flex">
                <Card
                  className="w-100 cursor-pointer hospital-card"
                  onClick={() => handleClickHospitalCard(hospital.userId)}
                >
                  <Card.Body>
                    {/* {hospital.hospitalLogo && ( */}
                    <div
                      style={{ height: "5rem" }}
                      className={
                        !hospital.hospitalLogo &&
                        "d-flex align-items-center justify-content-center"
                      }
                    >
                      <img
                        // variant="top"
                        className={hospital.hospitalLogo && "hospital-logo"}
                        src={
                          hospital.hospitalLogo
                            ? `${configuration.API_URL}auth/assets/${hospital.hospitalLogo}`
                            : noLogo
                        }
                        alt={`${hospital.hospitalName} Logo`}
                        width="50"
                      />
                      {!hospital.hospitalLogo && (
                        <span className="color-grey font-weight-bold">
                          No logo available
                        </span>
                      )}
                    </div>
                    {/* )} */}
                    {/* 
<Image
                width={100}
                src={hospitalData.hospitalLogo ? `${configuration.API_URL}auth/assets/${hospitalData.hospitalLogo}` : noLogo}
              /> */}

                    <Card.Title className="truncate-name">
                      {" "}
                      <Tooltip
                        placement="topLeft"
                        title={hospital.hospitalName}
                      >
                        {hospital.hospitalName}
                      </Tooltip>
                    </Card.Title>
                    <Card.Text className="truncate-name">
                      <Tooltip
                        placement="topLeft"
                        title={hospital.hospitalAddress}
                      >
                        {hospital.hospitalAddress}
                      </Tooltip>
                    </Card.Text>
                    <Card.Text className="truncate-name">
                      <Tooltip placement="topLeft" title={hospital.mailId}>
                        {hospital.mailId}
                      </Tooltip>
                    </Card.Text>
                    <Card.Text className="truncate-name">
                      <Tooltip placement="bottomLeft" title={hospital.phoneNo}>
                        {hospital.phoneNo}
                      </Tooltip>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))
          ) : (
            <Empty />
            // <Col>
            //   <p>No hospitals found.</p>
            // </Col>
          )}
        </Row>
        {paginationCount > 24 && (
          <Pagination
            pageSize={24}
            current={currentPage + 1}
            defaultCurrent={1}
            total={paginationCount}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        )}
      </Container>
    </div>
  );
}

export default HospitalList;
